var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftInvitePge"
  }, [_c('div', {
    staticClass: "nftInvitePge-preload",
    style: {
      background: `
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgblack.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgblue.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bggreen.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgorange.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgpink.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgred.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgyellow.png')})
      `
    }
  }), _c('div', {
    staticClass: "nft-body"
  }, [_c('div', {
    staticClass: "nft-bg",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/nft-bg.jpg')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "nft-main"
  }, [_c('div', {
    staticClass: "nft-shard"
  }, [_c('div', {
    staticClass: "nft-ship"
  }, [_c('div', {
    staticClass: "nft-ship-img"
  }, [_c('img', {
    staticClass: "ship",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/light.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "nft-ship__num"
  }, [_vm._v(_vm._s(_vm._f("fmt_pre")(_vm.fragInviteInfo.reward)) + "/" + _vm._s(_vm._f("fmt_pre")(_vm.fragInviteInfo.reward_total)))]), _c('div', {
    staticClass: "nft-btns"
  }, [!_vm.isClaimLoading ? _c('div', {
    staticClass: "btn-craft",
    on: {
      "click": _vm.onClaim
    }
  }, [[_vm._v("Claim")]], 2) : _c('div', {
    staticClass: "btn-craft"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])])])]), _c('div', {
    staticClass: "nft-menu"
  }, [_c('div', {
    staticClass: "nft-menu__title"
  }, [_vm._v("Invite to earn shards")]), _vm._m(0), _c('div', {
    staticClass: "nft-menu-btns"
  }, [_c('div', {
    staticClass: "btn-invite",
    on: {
      "click": _vm.onInvite
    }
  }, [_vm._v("Invite")]), _vm.setting ? _c('div', {
    directives: [{
      name: "copy",
      rawName: "v-copy",
      value: `https://t.me/${_vm.setting.botname}/app?startapp=ref_${_vm.userData.ref_code}-page_nfts\nGet your free Metacats NFT shards`,
      expression: "`https://t.me/${setting.botname}/app?startapp=ref_${userData.ref_code}-page_nfts\\nGet your free Metacats NFT shards`"
    }],
    staticClass: "btn-copy"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-body"
  }, [_vm.firendList && _vm.firendList.length > 0 ? [_vm._m(1), _vm._l(_vm.firendList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "form-item"
    }, [_c('m-head', {
      attrs: {
        "name": item,
        "bgColor": item.head_color,
        "fontSize": "13",
        "size": "30"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))])], 1);
  })] : [_c('div', {
    staticClass: "form-empty"
  }, [_vm._v("No records yet")])]], 2)])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1), _c('pop-reward', {
    attrs: {
      "show": _vm.popRewardShow,
      "data": _vm.rewardData
    },
    on: {
      "update:show": function ($event) {
        _vm.popRewardShow = $event;
      },
      "finish": _vm.popRewardFinish
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft-menu__sub"
  }, [_vm._v(" You can get a shard, When each of your friends"), _c('br'), _vm._v(" gets his first shard ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "form-head"
  }, [_c('span', [_vm._v("The friend who got the first shard")])]);
}];
export { render, staticRenderFns };